import React from "react";
import styled, { keyframes } from "styled-components";
import { FaPaperPlane, FaSpinner } from "react-icons/fa";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const IconButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: var(--chat-icon, #4a4a4a);
  &:hover:not(:disabled) {
    transform: translateY(-2px);
  }
  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;

const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

const Spinning = styled(FaSpinner)`
  animation: ${spin} 0.8s linear infinite;
`;

const ButtonLabel = styled.span`
  margin-left: 5px;
`;

export default function ChatSendButton({
  sending,
  disabled,
  onClick,
  className,
  title = "Send",
}) {
  return (
    <IconButton
      className={className}
      type="button"
      onClick={onClick}
      title={title}
      disabled={disabled}
    >
      <IconSlot>
        {sending ? <Spinning size={14} /> : <FaPaperPlane size={14} />}
      </IconSlot>
      <ButtonLabel>Submit</ButtonLabel>
    </IconButton>
  );
}
